import React from "react"
import SideContainerAnimated from "../SideContainer"
import SideForm from "../SideForm"
import { IFormAddDetails } from "./interface"
import pencil from "../../assets/icons/pencil.svg";
import * as Yup from "yup"
import Row from "../Row";
import { Field, Form, Formik } from "formik";
import Input from "../Input";
import Button from "../Button";
import { toast } from "react-toastify";
import { Legend } from "./style";
import { addDetail } from "../../hooks/addDetail";
import { errorHandlerApi } from "../../hooks/errorHandlerApi";
import { staticMessagesError } from "../../helpers/staticMessagesError";
import { toastCreate } from "../../utils/notifications/toast";
import { TIME_INFO } from "../../utils/notifications/time";

const FormAddDetails = ({
    isVisible,
    selectedProduct,
    formState,
    setRefresh
}: IFormAddDetails
): React.ReactElement => {

    const validationDetails = Yup.object().shape({
        details: Yup.string().required(),
        amount: Yup.string().nullable()
    })

    return (
        <>
            <SideContainerAnimated isVisible={isVisible}>
                <SideForm
                    title="Adicionar variação"
                    icon={pencil}
                    sizeIcon={20}
                    visible={() => formState("close")}
                >   
                    <Formik
                        initialValues={{
                            details: "",
                            amount: "",
                        }}
                        validationSchema={validationDetails}
                        onSubmit={async (values, {resetForm}) => {
                            const { isError } = await addDetail(values, selectedProduct)

                            if(!isError) {
                                formState("close")
                                resetForm()
                                setRefresh(true)
                            }
                        }}
                    >
                        {({ errors, dirty, isValid, touched }) => {
                            return (
                                <Form>
                                    <Row>
                                        <fieldset>
                                            <Legend>Adicione uma variação</Legend>
                                            <Field 
                                                id="details" 
                                                name="details" 
                                                className="inputCustom" 
                                                placeholder="Variação"
                                                isError={touched.details && errors.details}
                                                as={Input}
                                            />
                                            <Field 
                                                id="amount" 
                                                name="amount"
                                                type="tel"
                                                className="inputCustom" 
                                                placeholder="Valor"
                                                isError={touched.amount && errors.amount}
                                                as={Input}
                                            />
                                        </fieldset>
                                    </Row>
                                    <Row>
                                        <Button 
                                            onClick={() => {
                                                toastCreate(
                                                    "createDetail",
                                                    "info",
                                                    TIME_INFO,
                                                    "Processando..."
                                                )
                                            }}
                                            disabled={ !(dirty && isValid)}
                                            type="submit">
                                                Adicionar
                                        </Button>
                                    </Row>
                                </Form>
                            )
                        }}
                    </Formik>
                </SideForm>
            </SideContainerAnimated>
        </>
    )
}

export default FormAddDetails